import dayjs from 'hb-react/shared/utils/dayjs/dayjs';

// Expose dayjs globally
window.dayjs = dayjs;
